module.exports = __webpack_public_path__ + "static/media/Gousto_Discount.d0a56bb3.svg";